// extracted by mini-css-extract-plugin
module.exports = {"brand":"GlobalFooter__brand--3nrSG"};
    if(module.hot) {
      // 1541451117257
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  